import React from 'react';

import { SyncLoader } from 'halogenium';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

const ReferralLink = ({ referralLink, loading }) => {
  let linkText = '';
  if (!loading) {
    linkText = referralLink || 'Select a Property to Create a Referral Link';
  }

  return (
    <div
      style={{
        textAlign: 'center',
        margin: '50px 15px 0px 15px',
        padding: '25px',
        border: `1px dashed ${colors.GRAY}`,
        position: 'relative',
        background: 'rgb(253, 253, 253)',
        minHeight: '92px',
      }}
    >
      <p
        style={{
          textAlign: 'center',
          fontSize: '1.6em',
          lineHeight: '2',
          margin: '0',
          textColor: '#242424',
        }}
      >
        {linkText}
      </p>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '30px',
            bottom: '0',
            left: '0',
            right: '0',
          }}
        >
          <SyncLoader color={AccentColor()} size="16px" margin="auto" />
        </div>
      )}
    </div>
  );
};

export default ReferralLink;
